import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: transparent;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: transparent;\n']);

import React from 'react';
import styled from 'styled-components';
import ScrollLock from 'react-scrolllock';

var Blanket = styled.div(_templateObject);

export default function ScrollBlock() {
  return React.createElement(
    Blanket,
    null,
    React.createElement(ScrollLock, null)
  );
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/layer/dist/esm/components/internal/ScrollBlock.js
// module id = 644
// module chunks = 0